export default function OrderShipping({ order, handleEditShippingValue }) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Name
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('shipping.name', order.shipping.name)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.shipping.name}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Address Line 1
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('shipping.address.line1', order.shipping.address.line1)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.shipping.address.line1}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            City
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('shipping.address.city', order.shipping.address.city)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.shipping.address.city}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            State
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('shipping.address.state', order.shipping.address.state)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.shipping.address.state}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Postal Code
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('shipping.address.postal_code', order.shipping.address.postal_code)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.shipping.address.postal_code}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}